export default __webpack_public_path__ + "img/ef18840b6e946b988bc0044cc2e6905f.png";